import { gql } from "@apollo/client";
import { PRORATION_FRAGMENT } from "../../queries";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";

export const PAYMENT_QUERY = gql`
  query commercePayment($paymentId: ID!) {
    commercePayment(id: $paymentId) {
      id
      amountCents
      refundedAmountCents
      type
      paidAt
      source
      status
      transactionId
      transactionUrl
      stripeAccount
      referenceNumber
      payer {
        id
        name
        email
        type
      }
      orderPayments {
        id
        amountCents
        ledgerEntries {
          amountCents
          createdAt
          type
          secondaryLineItem {
            id
            name
            priceCents
          }
          lineItem {
            id
            name
            balance
            priceCents
            proratable
            proration {
              ...ProrationFragment
            }
          }
        }
        order {
          id
          status
          balance
          totalPaid
          description
          dueDate
          updatedAt
          eventRegistration {
            id
            event {
              title
              slug
              startsAt
              activityType
            }
          }
          lineItems {
            id
            priceCents
            name
            balance
            proration {
              ...ProrationFragment
            }
          }
          person {
            id
            firstName
            lastName
            profilePhoto
            pgaId
            mainProgramType {
              name
            }
          }
        }
      }
      notes {
        ...CRMNoteFields
      }
    }
  }

  ${PRORATION_FRAGMENT}
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;
